<template>
  <div class="hitwrapper">
    <div class="hittitle">
      <a :id="hit.id" :href="hit.url" class="documentIcon">
        {{ hit.title }}
        <Icon type="arrow-right"/>
      </a>
    </div>
    <div class="hittype" v-if="hitType !== ''">
      <span>
        <Icon :type="'text-document'"></Icon>
      </span>
      <span>{{ hitType }}</span>
      <span class="datetime" v-if="hitPublishDate !== ''">
        <Icon :type="'clock-o'"></Icon>
        <span>
        {{ this.texts.publicerad }} {{ formattedPublishDate }}
      </span>    
      </span>
      <span class="datetime" v-if="hitEventDuration !== ''">
        <Icon :type="'clock-o'"></Icon>
        <span>
          {{ formattadedEventDuration }}
        </span>    
      </span>   
    </div>
    <p v-html="hit.excerpt"></p>
    <Breadcrumb
      v-if="showBreadcrumb"
      :id="hit.id"
      :breadcrumb="hit.breadcrumb"
    ></Breadcrumb>
  </div>
</template>
<script>
import Icon from "../../../image/icon.vue";
import Breadcrumb from "../../components/breadcrumb.vue";
export default {
  name: "GenericItem",
  props: {
    hit: Object,
    texts: Object,
    showBreadcrumb: Boolean,
  },
  computed: {
    formattedPublishDate() {
      if (!this.hitPublishDate) return '';
      const date = new Date(this.hitPublishDate);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formattadedEventDuration() {
      if (!this.hitEventDuration) return '';
      return this.hitEventDuration.replace('kl.',this.texts.klockan).replace('till',this.texts.till);
    }
  },
  data: function () {
    return {
      hitType: "",
      hitPublishDate: "",
      hitEventDuration: "",
    };
  },
  components: {
    Icon,
    Breadcrumb,
  },
  created() {
    this.setType();
  },
  methods: {
    setType: function () {
      switch (this.hit.typeName) {
        case "epiumu.models.pages.utb.utbstudieplansida":
          this.hitType = this.texts.studieplan;
          break;
        case "epiumu.models.pages.utbkurssida":
          this.hitType = this.texts.kurs;
          break;
        case "epiumu.models.pages.utbprogramsida":
          this.hitType = this.texts.program;
          break;
        case "epiumu.models.pages.utbkurspaketsida":
          this.hitType = this.texts.kurspaket;
          break;
        case "epiumu.models.pages.utbamnessida":
          this.hitType = this.texts.amne;
          break;
        case "epiumu.models.pages.portrattreportagesida":
          this.hitType = this.texts.reportage;
          this.hitPublishDate = this.hit.publishDate;
          break;
        case "epiumu.models.pages.kalender.kalendereventsida":
          this.hitType = this.texts.event;
          this.hitEventDuration = this.hit.eventDuration;
          break;
        case "epiumu.models.pages.forskning.forskningsgruppsida":
          this.hitType = this.texts.forskningsgrupp;
          break;
        case "epiumu.models.pages.forskning.forskningsprojektsida":
          this.hitType = this.texts.forskningsprojekt;
          break;
        case "epiumu.models.pages.jobbsida":
          this.hitType = this.texts.jobb;
          break;
        case "epiumu.models.pages.regelsida":
          this.hitType = this.texts.regel;
          break;
        case "epiumu.models.pages.forskning.forskningsinfrastruktursida":
          this.hitType = this.texts.forskningsinfrastruktur;
          break;
        case "epiumu.models.pages.forskning.forskningsamnessida":
          this.hitType = this.texts.forskningsomrade;
          break;
        case "epiumu.models.pages.utbvalkomstbrevsida":
          this.hitType = this.texts.valkomstbrev;
          break;  
        case "cms.models.blocks.artikelblock":
        case "cms.models.blocks.imported.importeratartikelblock":
        case "epiumu.models.pages.nyhetssida":
          this.hitType = this.texts.nyhet;
          this.hitPublishDate = this.hit.publishDate;
          break;
        default:
          this.hitType = "";
      }
    },
  },
  watch: {
    hit: {
      deep: true,
      handler() {
        this.setType();
      },
    },
  },
};
</script>
